export default function AttachPreparationItemDocumentDirective() {
  return {
    template: require('./attach-preparation-item-document.html'),
    scope: {
      customerId: '=',
      preparationItemId: '=',
      serviceId: '=',
      parentDocumentId: '=',
      documentId: '=',
      document: '=',
    },
    controller: 'AttachPreparationItemDocumentController',
    controllerAs: 'attachPreparationItemDocumentVM',
    bindToController: true,
    replace: true
  };
}
